import $axios from './index'
import store from '@/store'

/** 部门切换后景区/ERP 列表需带 targetid */
function withTargetId(data) {
    const params = { ...(data || {}) }
    const tid = store.getters.targetid
    if (tid != null && tid !== '') {
        params.targetid = tid
    }
    return params
}

export function getBIOne(data) {
    const url = '/api/bi/sale_count/get_company_device_sort'
    return $axios.get(url, data)
}

// 退款数据
export function getBIRefund(data) {
    const url = '/api/bi/sale_count/get_refund_num'
    return $axios.get(url, data)
}

// 销售额走势图
export function getBISale(data) {
    const url = '/api/bi/sale_count/get_sale_sum_by_date'
    return $axios.get(url, data)
}

// 景区列表（随部门变更，自动附带 targetid）
export function getStoreList(data) {
    const url = '/api/bi/basic/get_company_list'
    return $axios.get(url, withTargetId(data))
}
// ERP 仓库列表（随部门变更，自动附带 targetid）
export function getErpStoreList(data) {
    const url = '/api/bi/basic/get_store_list'
    return $axios.get(url, withTargetId(data))
}

// 设备列表
export function getDeviceList(data) {
    const url = '/api/bi/basic/get_device_list'
    return $axios.get(url, data)
}

// 月指标
export function getSaleByYear(data) {
    const url = '/api/bi/sale_count/get_sale_by_year'
    return $axios.get(url, data)
}

// 设备、景区指标趋势
export function getTrendList(data) {
    const url = '/api/bi/sale_count/get_indicator_trend'
    return $axios.get(url, data)
}


// 景区指标表格
export function getSalesList(data) {
    const url = '/api/bi/sale_count/get_data_by_company'
    return $axios.get(url, data)
}

// 设备指标表格
export function getDeviceQuota(data) {
    const url = '/api/bi/device_analysis/get_device_index'
    return $axios.get(url, data)
}

// 获取设备离线时间
export function getDeviceOffline(data) {
    const url = '/api/bi/device_analysis/get_device_status'
    return $axios.get(url, data)
}

// 获取设备销售断线时间
export function getSaleOffline(data) {
    const url = '/api/bi/device_analysis/get_device_sale'
    return $axios.get(url, data)
}


// 获取为库存为负数
export function getIsNegative(data) {
    const url = '/api/bi/erp_order_analysis/get_is_negative'
    return $axios.get(url, data)
}

// 获取两月未变化
export function getNoChange(data) {
    const url = '/api/bi/erp_order_analysis/get_no_change'
    return $axios.get(url, data)
}

// 下载商品数据总览表
export function negativeDown(params ) {
    // 通过传递配置对象来设置 responseType
    return $axios.get('/api/bi/erp_order_analysis/download_is_negative', params, 'blob');
}

// 下载商品数据总览表
export function noChangeDown(params) {
    // 通过传递配置对象来设置 responseType
    return $axios.get('/api/bi/erp_order_analysis/download_no_change', params, 'blob');
}

// 获取下载的设备列表
export function getDeviceDownload(params) {
    const url = '/api/bi/device_analysis/down_load_device_surplus'
    return $axios.get(url, params, 'blob')
}

// 设备离线状态下载
export function getDeviceOfflineDownload(params) {
    const url = '/api/bi/device_analysis/get_device_off_line'
    return $axios.get(url, params, 'blob')
}
// 设备销售状态下载
export function getDeviceSaleDownload(params) {
    const url = '/api/bi/device_analysis/download_device_sale'
    return $axios.get(url, params, 'blob')
}

// get_device_num

export function getDeviceNum() {
    const url = '/api/bi/device_analysis/get_device_num'
    return $axios.get(url)
}

//
// 获取下载的设备列表
export function getStoreDownload(params) {
    const url = '/api/bi/sale_count/download_data_by_company'
    return $axios.get(url, params, 'blob')
}

// 获取商品销售数量
export function getGoodsList(data) {
    const url = '/api/bi/sale_count/get_goods_sale_sum'
    return $axios.get(url, data)
}

// 获取下载的商品销售数量列表
export function getGoodsDownload(params) {
    const url = '/api/bi/sale_count/download_goods_sale_sum'
    return $axios.get(url, params, 'blob')
}
// 获取退款分析
export function getRefundAnalysis(params) {
    const url = '/api/bi/sale_count/get_refund_analysis'
    return $axios.get(url, params)
}
export function getRefundAnalysisDownload(params) {
    const url = '/api/bi/sale_count/download_refund_analysis_by_status'
    return $axios.get(url, params,'blob')
}
export function getRefundAnalysisDownloadTwo(params) {
    const url = '/api/bi/sale_count/download_refund_analysis_by_refund'
    return $axios.get(url, params,'blob')
}
export function getRefundAnalysisDownloadThree(params) {
    const url = '/api/bi/sale_count/download_refund_analysis'
    return $axios.get(url, params,'blob')
}
// 获取退款分析
export function getRefundAnalysisReason(params) {
    const url = '/api/bi/sale_count/get_device_by_refund_reason'
    return $axios.get(url, params)
}
// 获取退款分析
export function getRefundAnalysisStatus(params) {
    const url = '/api/bi/sale_count/get_refund_by_status_by_devices'
    return $axios.get(url, params)
}
// 获取退款分析
export function getRefundAnalysisDevices(params) {
    const url = '/api/bi/sale_count/get_refund_by_reason_by_devices'
    return $axios.get(url, params)
}
export function getRefundAnalysisDownloadStatus(params) {
    const url = '/api/bi/sale_count/download_refund_by_status_by_devices'
    return $axios.get(url, params,'blob')
}
export function getRefundAnalysisDownloadReason(params) {
    const url = '/api/bi/sale_count/download_refund_by_reason_by_devices'
    return $axios.get(url, params,'blob')
}

export function getExchangeRate(data) {
    const url = '/api/bi/sale_count/get_exchange_rate'
    return $axios.get(url, data)
}

export function getChildrenOrg(data) {
    const url = '/api/bi/sale_count/get_children_org'
    return $axios.get(url, data)
}

// ========== 新版销售分析 /api/bi/new_sale ==========
const NEW_SALE_BASE = '/api/bi/new_sale'

function withSkipLoading(data) {
    return { ...(data || {}), skipGlobalLoading: true }
}

/** 销售汇总（含同比环比） */
export function getNewSaleSum(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_sale_sum`, withSkipLoading(data))
}

/** 商品销售汇总（SKU 去重） */
export function getNewGoodsSum(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_goods_sum`, withSkipLoading(data))
}

/** 销售景区汇总（接口名 erp_company = 销售景区） */
export function getNewErpCompanySum(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_erp_company_sum`, withSkipLoading(data))
}

/** 退款汇总 */
export function getNewRefundSum(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_refund_sum`, withSkipLoading(data))
}

/** 销售金额/订单/设备日趋势 */
export function getNewSaleAmountTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_sale_amount_trend`, withSkipLoading(data))
}

/** 商品销售日趋势 */
export function getNewGoodsSumTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_goods_sum_trend`, withSkipLoading(data))
}

/** 销售景区日趋势（接口名 erp_company = 销售景区） */
export function getNewErpCompanyTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_erp_company_trend`, withSkipLoading(data))
}

/** 退款日趋势 */
export function getNewRefundTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_refund_trend`, withSkipLoading(data))
}

/** 来源销售（设备类型占比） */
export function getNewSourceTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_source_trend`, withSkipLoading(data))
}

/** 地区销售排名 */
export function getNewRegionTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_region_trend`, withSkipLoading(data))
}

/** 景区类型销售 */
export function getNewCompanyTypeTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_company_type_trend`, withSkipLoading(data))
}

/** 省份销售 */
export function getNewCompanyProvinceTrend(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_company_province_trend`, withSkipLoading(data))
}

/** 各景区销售 */
export function getNewCompanyName(data) {
    return $axios.get(`${NEW_SALE_BASE}/get_company_name`, withSkipLoading(data))
}